module.exports = __webpack_public_path__ + "img/media_20240408_224931_4638502498359788652.76d70f52.jpg";